import { Component, inject, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-externalsite-alert',
    templateUrl: './externalsite-alert.component.html',
    styleUrls: ['./externalsite-alert.component.scss'],
    standalone: false
})
export class ExternalsiteAlertComponent {
  private readonly modalService = inject(NgbModal);

  @Input() public eventReference;

  redirectto(){
    window.open(this.eventReference);
    this.modalService.dismissAll();
  }
  dismissModal(){
    this.modalService.dismissAll();
  }
}
